import { Injectable } from '@angular/core';
import {
  HttpClient,
  HttpHeaders
} from '@angular/common/http';

import {
  ApplicantType, FacilityType, OwnershipType, MLevel, MRLevel, EducationLevel,
  ProfessionalType, QualificationType, RegionType, ZoneType, WoredaType,
  ProductType, SpecificProduct, ApplicationStatus, City, SpecificProductItem, ApplicationCategory, BranchOffice, ProfessionalField, SubCityType
} from '../../models/CommonModels';

import {
  Observable,
  of
} from 'rxjs';

import {
  catchError,
  tap
} from 'rxjs/operators';

import { environment } from '../../../environments/environment';
import {AccountService} from "../../services/account.service";
import { ChangeType } from '../../models/ApplicationDetail';
import * as Constants from '../../models/Constants';
import { DocumentRef } from '../../models/DocumentRef';
import { SubDataVariables } from '../../../environments/app.variables';
import { WorkflowActionModel } from '../../models/WorkflowActionModel';

const httpOptions = {
  headers: new HttpHeaders({
    'Content-Type': 'application/json'
  })
};

@Injectable({
  providedIn: 'root'
})
export class CommonService {

  private applicationCategoryUrl = environment.baseUrl +'/ApplicationCategory';
  private applicantTypeUrl = environment.baseUrl +'/ApplicantType';
  private productTypeUrl = environment.baseUrl +'/ProductType';
  private facilityTypeUrl = environment.baseUrl +'/FacilityType';
  private ownershipTypeUrl = environment.baseUrl +'/OrganizationType';
  private mLevelUrl = environment.baseUrl +'/MLevel';
  private mRLevelUrl = environment.baseUrl +'/MRLevel';
  private qualifTypesUrl = environment.baseUrl +'/Qualification';
  private educationLevelUrl = environment.baseUrl +'/EducationLevel';
  private professionalTypeUrl = environment.baseUrl +'/ProfessionalType';
  private woredaTypeUrl = environment.baseUrl +'/Woreda';
  private subCityTypeUrl = environment.baseUrl +'/SubCity';
  private zoneTypeUrl = environment.baseUrl +'/Zone';
  private regionTypeUrl = environment.baseUrl +'/Region';
  private specificProductUrl = environment.baseUrl + '/SpecificProduct';
  private specificProductItemUrl = environment.baseUrl + '/SpecificProductItem';
  private appStatusUrl = environment.baseUrl + '/ApplicationStatus';
  private cityUrl = environment.baseUrl + '/City';
  private branchOfficeURL = environment.baseUrl + '/BranchOffice';
  private changeTypeURL = environment.baseUrl + '/ChangeType';
  private professionalFieldsURL = environment.baseUrl + '/ProfessionalField';
  private departmentUrl = environment.baseUrl + '/Department';
  private documentRefUrl = environment.baseUrl + '/DocumentRef';

  constructor(private http: HttpClient, private accountService: AccountService) {
    httpOptions.headers = httpOptions.headers.set('Authorization', 'Bearer '+ this.accountService.getTokenData());
  }


  /** GET applicationTypes from the server */
  getApplicationTypes(): Observable<ApplicantType[]> {
    return this.http.get<ApplicantType[]>(this.applicantTypeUrl,httpOptions)
      .pipe(
        tap(_ => this.log('fetched applicationTypes')),
        catchError(this.handleError('getApplicationTypes', []))
      );
  }

  /** GET applicationCategories from the server */
  getApplicationCategories(): Observable<ApplicationCategory[]> {
    return this.http.get<ApplicationCategory[]>(this.applicationCategoryUrl, httpOptions)
      .pipe(
        tap(_ => this.log('fetched application categories')),
        catchError(this.handleError('getApplicationCategories', []))
      );
  }

   /** GET ProductTypes from the server */
   getProductTypes(facilityTypeID :number = 0, tempCOC: boolean = false): Observable<ProductType[]> {
     if(facilityTypeID == 0)
     {
      return this.http.get<ProductType[]>(this.productTypeUrl, httpOptions);
     }else{
      return this.http.get<ProductType[]>(this.productTypeUrl+  '/' + facilityTypeID + '/' + tempCOC ,httpOptions);
     }
  }
   /** GET ProfessionalField from the server */
   getProfessionalFields(): Observable<ProfessionalField[]> {
    return this.http.get<ProfessionalField[]>(this.professionalFieldsURL, httpOptions)
      .pipe(
        tap(_ => this.log('fetched professionalFields')),
        catchError(this.handleError('getProfessionalFields', []))
      );
  }

  /** GET FacilityTypes from the server */
  getFacilityTypes(filter:boolean): Observable<FacilityType[]> {
    return this.http.get<FacilityType[]>(this.facilityTypeUrl+'/'+filter,httpOptions)
      .pipe(
        tap(_ => this.log('fetched FacilityTypes')),
        catchError(this.handleError('getFacilityTypes', []))
      );
  }
  /** GET ChangeTyes from the server */
  getChangeTypesByFacilityAndProductType(facilityTypeID : number, productTypeID : number, appCategoryCode):Observable<ChangeType[]>{
    return this.http.get<ChangeType[]>(this.changeTypeURL + '/' + 'ByFacilityAndProductType' + '/' + facilityTypeID + '/' + productTypeID + 
    '/' + (appCategoryCode === Constants.APPLICATION_TYPE_CODE_TEMP_CHANGE ? true : false), httpOptions)
    .pipe(
      tap(_ => this.log('fetched ChangeTypes')),
      catchError(this.handleError('getChangeTypes', []))
    );
  }

   /** GET OwnershipTypes from the server */
   getOwnershipTypes(): Observable<OwnershipType[]> {
    return this.http.get<OwnershipType[]>(this.ownershipTypeUrl,httpOptions)
      .pipe(
        tap(_ => this.log('fetched OwnershipTypes')),
        catchError(this.handleError('getOwnershipTypes', []))
      );
  }

  /** GET MLevels from the server */
  getMLevels(): Observable<MLevel[]> {
    return this.http.get<MLevel[]>(this.mLevelUrl,httpOptions)
      .pipe(
        tap(_ => this.log('fetched MLevels')),
        catchError(this.handleError('getMLevels', []))
      );
  }

  /** GET MRLevels from the server */
  getMRLevels(): Observable<MRLevel[]> {
    return this.http.get<MRLevel[]>(this.mRLevelUrl,httpOptions)
      .pipe(
        tap(_ => this.log('fetched MRLevels')),
        catchError(this.handleError('getMRLevels', []))
      );
  }

  /** GET EducationLevels from the server */
  getEducationLevels(filter:boolean): Observable<EducationLevel[]> {
    return this.http.get<EducationLevel[]>(this.educationLevelUrl + '/'+ filter,httpOptions)
      .pipe(
        tap(_ => this.log('fetched EducationLevels')),
        catchError(this.handleError('getEducationLevels', []))
      );
  }

   /** GET ProfessionalTypes from the server */
  getProfessionalTypes(): Observable<ProfessionalType[]> {
    return this.http.get<ProfessionalType[]>(this.professionalTypeUrl,httpOptions)
      .pipe(
        tap(_ => this.log('fetched ProfessionalTypes')),
        catchError(this.handleError('getProfessionalTypes', []))
      );
  }
  /** GET MLevels from the server */
  getQualificationTypes(): Observable<QualificationType[]> {
    return this.http.get<QualificationType[]>(this.qualifTypesUrl,httpOptions)
      .pipe(
        tap(_ => this.log('fetched QualificationType')),
        catchError(this.handleError('getQualificationTypes', []))
      );
  }


   /** GET RegionTypes from the server */
  getRegionTypes(): Observable<RegionType[]> {
    return this.http.get<RegionType[]>(this.regionTypeUrl,httpOptions)
      .pipe(
        tap(_ => this.log('fetched Region Types')),
        catchError(this.handleError('getRegionTypes', []))
      );
  }

   /** GET WoredaTypes from the server */
  getWoredaTypes(): Observable<WoredaType[]> {
    return this.http.get<WoredaType[]>(this.woredaTypeUrl,httpOptions)
      .pipe(
        tap(_ => this.log('fetched Woreda Types')),
        catchError(this.handleError('getWoredaTypes', []))
      );
  }

  getSubCityTypes(): Observable<SubCityType[]> {
    return this.http.get<SubCityType[]>(this.subCityTypeUrl,httpOptions)
  }

   /** GET ZoneTypes from the server */
  getZoneTypes(): Observable<ZoneType[]> {
    return this.http.get<ZoneType[]>(this.zoneTypeUrl, httpOptions)
      .pipe(
        tap(_ => this.log('Fetched Zone Types')),
        catchError(this.handleError('getZoneTypes', []))
      );
  }

   /** GET ZoneTypes by regionID  */
  getZoneTypesByRegion(regionID): Observable<ZoneType[]> {
    return this.http.get<ZoneType[]>(this.zoneTypeUrl+ '/byRegion/'+ regionID , httpOptions)
      .pipe(
        tap(_ => this.log('Fetched Zone Types for regionID '+regionID)),
        catchError(this.handleError('getZoneTypesByRegionID', []))
      );
  }

   /** GET ZoneTypes by regionID  */
   getWoredaTypesByZone(zoneID): Observable<WoredaType[]> {
    return this.http.get<WoredaType[]>(this.woredaTypeUrl+ '/byZone/'+ zoneID , httpOptions)
      .pipe(
        tap(_ => this.log('Fetched Woreda Types for zoneID '+zoneID)),
        catchError(this.handleError('getWoredaTypesByZoneID', []))
      );
  }

  getWoredaTypesBySubCity(subCityID): Observable<WoredaType[]> {
    return this.http.get<WoredaType[]>(this.woredaTypeUrl+ '/bySubCity/'+ subCityID , httpOptions);
  }

  getSubCityTypesByZone(zoneID): Observable<SubCityType[]> {
    return this.http.get<SubCityType[]>(this.subCityTypeUrl+ '/byZone/'+ zoneID , httpOptions);
  }
  /**
   * Handle Http operation that failed.
   * Let the app continue.
   * @param operation - name of the operation that failed
   * @param result - optional value to return as the observable result
   */
   handleError < T > (operation = 'operation', result ? : T) {
    return (error: any): Observable < T > => {

      // TODO: send the error to remote logging infrastructure
      console.error(error); // log to console instead

      // TODO: better job of transforming error for user consumption
      this.log(`${operation} failed: ${error.message}`);

      // Let the app keep running by returning an empty result.
      return of(result as T);
    };
  }

  /** Log a HeroService message with the MessageService */
   log(message: string) {
    //this.messageService.add(`HeroService: ${message}`);
    console.log(`HeroService: ${message}`)
  }

  addQualification(qualificatationType: QualificationType){
    return this.http.post<QualificationType>(this.qualifTypesUrl, qualificatationType, {});
  }

  getSpecificProducts(): Observable<SpecificProduct[]> {
    return this.http.get<SpecificProduct[]>(this.specificProductUrl,httpOptions)
      .pipe(
        tap(_ => this.log('fetched Specific products')),
        catchError(this.handleError('getSpecificProducts', []))
      );
  }

  getFilteredSpecificProducts(facilityTypeID : number, productTypeID : number) : Observable<SpecificProduct[]> {
    return this.http.get<SpecificProduct[]>(this.specificProductUrl + '/' + facilityTypeID + '/' + productTypeID, {})
      .pipe(
        tap(_ => this.log('fetched Specific products by facility type')),
        catchError(this.handleError('getSpecificProductsByFacilityType', []))
      );
  }
  getSpecificProductsByproductType(productTypeID: number): Observable<SpecificProduct[]> {
    return this.http.get<SpecificProduct[]>(this.specificProductUrl + '/ByProductType/' + productTypeID, httpOptions)
      .pipe(
        tap(_ => this.log('fetched Specific products by product type')),
        catchError(this.handleError('getSpecificProductsByproductType', []))
      );
  }

  getFilteredSpecificProductItems(specificProductIds: number[]): Observable<SpecificProductItem[]> {
    const specificProductFilter = {'specificProductIds': specificProductIds};
    return this.http.post<SpecificProductItem[]>(this.specificProductItemUrl + '/BySpecificProducts', specificProductFilter, httpOptions)
      .pipe(
        tap(_ => this.log('fetched Specific product items by specificProductIds')),
        catchError(this.handleError('getFilteredSpecificProductItems', []))
      );
  }

  getSpecificProductItems(specificProductId: number): Observable<SpecificProductItem[]> {
    return this.http.get<SpecificProductItem[]>(this.specificProductItemUrl + '/BySpecificProduct/' + specificProductId,  httpOptions)
      .pipe(
        tap(_ => this.log('fetched Specific product items by specificProductIds')),
        catchError(this.handleError('getFilteredSpecificProductItems', []))
      );
  }

  getSpecificProductItemsByFacilityTypeAndProductType(facilityTypeId: number, productTypeId: number): Observable<SpecificProductItem[]> {
    return this.http.get<SpecificProductItem[]>(this.specificProductItemUrl + '/Filter/' + facilityTypeId + '/' + productTypeId,  httpOptions)
      .pipe(
        tap(_ => this.log('fetched Specific product items by specificProductIds')),
        catchError(this.handleError('getFilteredSpecificProductItems', []))
      );
  }

  getAllSpecificProductItems(): Observable<SpecificProductItem[]> {
    return this.http.get<SpecificProductItem[]>(this.specificProductItemUrl,  httpOptions)
      .pipe(
        tap(_ => this.log('fetched Specific product items')),
        catchError(this.handleError('getFilteredSpecificProductItems', []))
      );
  }

  getApplicationStatuses() {
    return this.http.get<ApplicationStatus[]>(this.appStatusUrl)
    .pipe(
      tap(_ => this.log('fetched application statuses')),
      catchError(this.handleError('getApplicationStatuses', []))
    );
  }

  /* Get cities list from server */
  getCities(): Observable<City[]> {
    return this.http.get<City[]>(this.cityUrl, httpOptions)
      .pipe(
        tap(_ => this.log('fetched cities')),
        catchError(this.handleError('getCities', []))
      );
  }
  /* Get cities list from server */
  getBranchOffices(): Observable<BranchOffice[]> {
    return this.http.get<BranchOffice[]>(this.branchOfficeURL, httpOptions)
      .pipe(
        tap(_ => this.log('fetched branches')),
        catchError(this.handleError('getBranchOffices', []))
      );
  }

  addCity(city: City) {
    return this.http.post<City>(this.cityUrl, city, {});
  }

  fetchDocument(url) {
    httpOptions['responseType'] = 'blob';
    return this.http.get < any > (url, httpOptions)
      .pipe(
        tap((application: any) => this.log(`document fetch successful`)),
        catchError(this.handleError < any > ('document fetch failed'))
      );
  }

  getDepartments(): Observable<ProductType[]> {
     return this.http.get<ProductType[]>(this.departmentUrl,httpOptions);
  }

  getDocRefByName(docRefName : string) : Observable<DocumentRef> {
    return this.http.get<DocumentRef>(this.documentRefUrl + '/GetByName/' + docRefName);
  }

  // set documentName only when there are more than one documents for that documentReference
  getSystemFile(documentRefrenceName, documentName) {
    httpOptions['responseType'] = 'blob';
    return this.http.get <any> (`${SubDataVariables.SYSTEM_FILE_URL}/${documentRefrenceName}/${documentName}`, httpOptions);
  }

  getWorkflowActions(workflowUrl) {
    return this.http.get<WorkflowActionModel[]>(workflowUrl);
  }

}
